import "./order.css";
import { Row, Col, Card, Modal, Form } from "react-bootstrap";
import { getOrderApi } from "../../api/api";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import location from "../../assets/locationorange.svg";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import { Rating } from "react-simple-star-rating";
import { postReviewApi } from "../../api/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../components/header";
import image from "../../assets/image/home.webp";
import { useNavigate } from "react-router-dom";
import { handleError } from "../../helpers/handleError";
import SpinLoading from "../../components/spinLoading/SpinLoading";
 
const Order = () => {
  const [order, setOrder] = useState([]);
  const token = useSelector((state) => state.auth.accessToken);
  const [show, setShow] = useState(false);
  const [rating, setRating] = useState(0);
  const [reviewproduct, setReviewProduct] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const fetchOrder = async () => {
    try {
      setLoading(true);
      const res = await getOrderApi(token);
      if (res.status === 200) {
        setOrder(res.data.info);
      }
    } catch (error) {
        handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false);
    setRating(0);
    reset();
  };
  const handleShow = (id) => {
    setShow(true);
    setReviewProduct(id);
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const body = {
        rating: rating,
        comment: data.comment,
        eventid: reviewproduct,
      };
      const res = await postReviewApi(token, body);
      if (res.status === 200) {
        toast.success("Reseña publicada con éxito");
        setShow(false);
        reset();
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const nav = [
    {
      title: "Inicio",
      path: "/event",
    },
    {
      title: "Historial de eventos",
      path: "/eventhistory",
    },
  ];

  useEffect(() => {
    if (token) fetchOrder();
  }, [token]);
  if (loading)
    return (
      <>
        <Header imageSrc={image} title="Historial de eventos" navigation={nav} />
        <SpinLoading />
      </>
    )
  return (
    <>
      <Header imageSrc={image} title="Historial de eventos" navigation={nav} />
      <div className="pading150 order-container ">
        <ToastContainer />
        {order.length === 0 ? (
          <div className="cart-item-empty-container pading150">
            <span className="cart-empty-text">No se encontraron pedidos. </span>
            <span
              className="cart-empty-text"
              style={{ cursor: "pointer", color: "#ec6325" }}
              onClick={() => navigate("/event")}
            >
              Ir al inicio
            </span>
          </div>
        ) : (
          <>
            {order.map((item) => (
              <Card className="order-card">
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={2} style={{ padding: "0px" }}>
                    <Card.Img src={item.eventid.image} alt="order" className="order-image" />
                  </Col>
                  <Col xs={12} md={7} style={{ padding: "0px" }}>
                    <Card.Body className="order-body">
                      <Card.Title
                        className="order-title"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          navigate(`/event/${item.eventid._id}`, { state: { name: item.eventid.name } });
                        }}
                      >
                        {item.eventid.name}
                      </Card.Title>
                      <Card.Text className="order-location">
                        <img src={location} alt="location" /> {item.eventid.fulladdress}
                      </Card.Text>
                      <Card.Text className="order-date">{dayjs(item.createdAt).format("DD MMM, YYYY")}</Card.Text>
                    </Card.Body>
                  </Col>
                  {dayjs(String(item.eventid.endDate || '').slice(0,10)).isBefore(dayjs(), 'day') && (
                    <Col xs={12} md={3} className="leave-review-container" style={{ padding: "0px" }}>
                      <button className="leave-review" onClick={() => handleShow(item.eventid._id)}>
                        <span className="leave-review-transition"></span>
                        <span className="label">Dejar reseña</span>
                      </button>
                    </Col>
                  )}
                </Row>
              </Card>
            ))}
            <Modal className="leave-review-modal" size="lg" show={show} onHide={handleClose} centered>
              <Modal.Body>
                <Form className="leave-review-modal-form" onSubmit={handleSubmit(onSubmit)}>
                  <div>
                    <span>Calificación: </span>
                    <Rating
                      allowFraction
                      onClick={(rate) => {
                        setRating(rate);
                      }}
                      transition
                      size={20}
                      fillColor="#EC6325"
                    />
                  </div>

                  <Form.Group>
                    <Form.Control
                      {...register("comment", { required: "El comentario es obligatorio" })}
                      as="textarea"
                      type="text"
                      placeholder="Comentario*"
                      className="leave-review-textarea"
                      rows={5}
                    />
                    {errors.comment && <p className="text-danger">{errors.comment.message}</p>}
                  </Form.Group>

                  <button className="buttonsearchevent" type="submit" disabled={loading}>
                    {loading ? <SpinLoading /> : "Post Review"}
                  </button>
                </Form>
              </Modal.Body>
            </Modal>
          </>
        )}
      </div>
    </>
  );
};

export default Order;
